export default __webpack_public_path__ + "static/media/28.17b1ef57.jpg";